import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { PeriodBarModule } from '../../../../../components/period-bar/period-bar.module';
import { CreditRowModule } from '../../components/credit-row/credit-row.module';
import { CreditComponent } from './credit.component';

@NgModule({
  declarations: [CreditComponent],
  imports: [
    CommonModule,
    CreditRowModule,
    BsDropdownModule,
    InfiniteScrollModule,
    NgxBootstrapIconsModule,
    NgxInnerLoadingModule,
    PeriodBarModule,
  ],
  exports: [CreditComponent],
})
export class CreditModule {}
